import React, { Suspense } from "react";
import { Routes, Outlet } from "react-router-dom";
import { updatePassword } from "./rutes/updatePassword";
import { tareasCliente } from "./rutes/tareasCliente";
import { casoArchivadoCliente } from "./rutes/casoArchivadoCliente";
import { casoCliente } from "./rutes/casoCliente";
import { tareas } from "./rutes/tareas";
import { caso } from "./rutes/caso";
import { tareaDetalleAprobarServiceRequest } from "./rutes/tareaDetalleAprobarServiceRequest";
import { tareaDetalleRevisarPedido } from "./rutes/tareaDetalleRevisarPedido";
import { tareaDetalleAnalisisCasoParticular } from "./rutes/tareaDetalleAnalisisCasoParticular";
import { tareaDetalleGestionarClienteDisconforme } from "./rutes/tareaDetalleGestionarClienteDisconforme";
import { tareaDetalleSolicitarHorasAdicionales } from "./rutes/tareaDetalleSolicitarHorasAdicionales";
import { tareaDetalleEstimar } from "./rutes/tareaDetalleEstimar";
import { tareaDetalleAprobar } from "./rutes/tareaDetalleAprobar";
import { casoArchivadoDetalle } from "./rutes/casoArchivadoDetalle";
import { casoDetalle } from "./rutes/casoDetalle";
import { tareaDetalleMasInformacion } from "./rutes/tareaDetalleMasInformacion";
import { cuenta } from "./rutes/cuenta";
import { accountManager } from "./rutes/accountManager";
import { accountManagerCuentaCleringDetalle } from "./rutes/accountManagerCuentaCleringDetalle";
import { tareaDetalleCalificarFinalizar } from "./rutes/tareaDetalleCalificarFinalizar";
import { tareaDetalleResolver } from "./rutes/tareaDetalleResolver";
import { tareaDetalleNegociarClienteEstimacionDesaprobada } from "./rutes/tareaDetalleNegociarClienteEstimacionDesaprobada";
import { forgotPassword } from "./rutes/forgotPassword";
import { barraNotFound } from "./rutes/barraNotFound";
import { notFound } from "./rutes/notFound";
import { login } from "./rutes/login";
import { loginRedirect } from "./rutes/loginRedirect";
import { home } from "././rutes/home";
import { oauth } from "./rutes/oauth";
import { tareaDetalleEstimacionSinAtender } from "./rutes/tareaDetalleEstimacionSinAtender";
import { tareasOperador } from "./rutes/tareasOperador";
import { nuevaGuardia } from "./rutes/nuevaGuardia";
import { guardia } from "./rutes/guardia";
import { guardias } from "./rutes/guardias";
import { tareaDetalleResolverOperador } from "./rutes/tareaDetalleResolverOperador";
import { guardiaTecnico } from "./rutes/guardiaTecnico";
import { nuevoServiceRequest } from "./rutes/nuevoServiceRequest";
import { nuevaTareaProgramada } from "./rutes/nuevoTareaProgramada";
import { tareaProgramada } from "./rutes/tareaProgramada";
import { tareasProgramadas } from "./rutes/tareasProgramadas";
import { tareaDetalleGestionarTareaProgramada } from "./rutes/tareaDetalleGestionarTareaProgramada";
import { tareaDetalleValidacion } from "./rutes/tareaDetalleValidacion";
import { tareaDetalleResolverTp } from "./rutes/tareaDetalleResolverTp";
import { tareaDetalleEvaludarDisponibilidad } from "./rutes/tareaDetalleEvaludarDisponibilidad";
import { tareaDetalleEscalacion } from "./rutes/tareaDetalleEscalacion";
import Spinner from "./components/layout/AppHeader/spinner";
import { nuevoIncidente } from "./rutes/nuevoIncidente";
import { nuevoProyecto } from "./rutes/proyecto";
import { tareaDetalleReunion } from "./rutes/tareaDetalleReunion";
import { tareaDetalleTareaSimple } from "./rutes/tareaDetalleTareaSimple";
import { tareaDetalleGestionarCasoVencido } from "./rutes/tareaDetalleGestionarCasoVencido";
import { tareasResourceManager } from "./rutes/tareasResouceManager";
import { nuevoCasoSimplificado } from "./rutes/nuevoCasoSimplificado";
import { solicitudCargaManual } from "./rutes/solicitudCargaManual";
import { tareaDetalleMasInfoTecnico } from "./rutes/tareaDetalleMasInfoTecnico";
import { tareaDetalleValidarPedido } from "./rutes/tareaDetalleValidarPedido";
import { tareaDetalleAprobarPedido } from "./rutes/tareaDetalleAprobarPedido";
import { tareaDetalleSolicitud } from "./rutes/tareaDetalleSolicitud";
import { tareaDetalleMasInfoRM } from "./rutes/tareaDetalleMasInfoRM";
import { SessionManager } from "./rutes/SessionManager";
import { entradasFiltradas } from "./rutes/entradasFiltradas";
import { notificacionesAbm } from "./rutes/notificacionesAbm";
import { busquedaCasosTareas } from "./rutes/busquedaCasosTareas";
import { tareaDetalleEsperarInformacion } from "./rutes/tareaDetalleEsperarInformacion";
export const UpdatePassword = React.lazy(
  () => import("./components/UpdatePassword/updatePassword"),
);
export const AppContext = React.createContext({});

export function AppLayout() {
  return (
    <Suspense fallback={<Spinner />}>
      <SessionManager />
      <Outlet />
    </Suspense>
  );
}

export function AppRoutes() {
  return (
    <>
      {/*region autenticacion */}
      {oauth()}
      {login()}
      {loginRedirect()}
      {updatePassword()}
      {forgotPassword()}
      {/*fin region autenticacion */}
      {/*//////////////////////////////////////*/}
      {/*region case and task*/}
      {home()}
      {busquedaCasosTareas()}
      {entradasFiltradas()}
      {caso()}
      {tareas()}
      {casoDetalle()}
      {casoArchivadoDetalle()}
      {notificacionesAbm()}
      {/*fin region  case and task*/}
      {/*//////////////////////////////////////*/}
      {/*region role cliente */}
      {nuevoServiceRequest()}
      {nuevoIncidente()}
      {nuevaTareaProgramada()}
      {tareaProgramada()}
      {nuevoProyecto()}
      {cuenta()}
      {accountManager()}
      {accountManagerCuentaCleringDetalle()}
      {tareaDetalleCalificarFinalizar()}
      {tareaDetalleMasInformacion()}
      {tareaDetalleAprobar()}
      {/*fin region role cliente */}
      {/*//////////////////////////////////////*/}
      {/*region  tecnical*/}
      {nuevoCasoSimplificado()}
      {solicitudCargaManual()}
      {tareaDetalleEstimar()}
      {tareaDetalleResolver()}
      {tareaDetalleEsperarInformacion()}
      {tareaDetalleReunion()}
      {tareaDetalleTareaSimple()}
      {guardiaTecnico()}
      {tareaDetalleValidacion()}
      {tareaDetalleResolverTp()}
      {tareaDetalleMasInfoTecnico()}
      {/*fin region tecnical */}
      {/*//////////////////////////////////////*/}
      {/*region  operador*/}
      {tareaDetalleResolverOperador()}
      {/*fin region operador */}
      {/*//////////////////////////////////////*/}
      {/*region resource manager*/}
      {tareaDetalleSolicitarHorasAdicionales()}
      {tareaDetalleEstimacionSinAtender()}
      {nuevaGuardia()}
      {guardia()}
      {guardias()}
      {tareasProgramadas()}
      {tareaDetalleEvaludarDisponibilidad()}
      {tareaDetalleEscalacion()}
      {tareaDetalleMasInfoRM()}
      {tareaDetalleValidarPedido()}
      {/*fin region  resource manager */}
      {/*//////////////////////////////////////*/}
      {/*region account manager*/}
      {tareaDetalleGestionarClienteDisconforme()}
      {tareaDetalleAnalisisCasoParticular()}
      {tareaDetalleReunion()}
      {tareaDetalleRevisarPedido()}
      {tareaDetalleNegociarClienteEstimacionDesaprobada()}
      {tareaDetalleAprobarServiceRequest()}
      {casoCliente()}
      {tareasCliente()}
      {tareasResourceManager()}
      {casoArchivadoCliente()}
      {tareaDetalleGestionarTareaProgramada()}
      {tareaDetalleGestionarCasoVencido()}
      {tareaDetalleSolicitud()}
      {tareaDetalleAprobarPedido()}
      {/*fin region account manager */}
      {/*//////////////////////////////////////*/}
      {/*region operado*/}
      {tareasOperador()}
      {/*fin region operador */}
      {/*//////////////////////////////////////*/}
      {barraNotFound()}
      {notFound()}
    </>
  );
}

export default AppLayout;
